/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IStudy } from 'app/shared/model/study.model';
import { IEquipment } from 'app/shared/model/equipment.model';

export interface ISeries {
  id?: string;
  seriesInstanceUid?: string | null;
  seriesNumber?: number | null;
  seriesDescription?: string | null;
  bodyPartExamined?: string | null;
  patientPosition?: string | null;
  laterality?: string | null;
  protocolName?: string | null;
  operatorsName?: string | null;
  seriesDateTime?: dayjs.Dayjs | null;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  statusCode?: string | null;
  study?: IStudy;
  equipment?: IEquipment;
}

export const defaultValue: Readonly<ISeries> = {
  active: false,
};
